<div class="map-loader">
    <div class="map-loader-module">
        <div class="map-loader-content"></div>
    </div>
</div>
